import React from "react";
import AcceptAutoFinanceWrapper from "../AcceptAutoFinance.styles";
import { Paragraph } from "@components/paragraph";
import SectionHeading from "@components/sectionHeading";
import environmentSettings from "@src/constants/environmentSettings";

export default function SuccessClientMessage() {
  const { phone } = environmentSettings;

  return (
    <AcceptAutoFinanceWrapper maxWidth="720px">
        <SectionHeading heading="Thank you for going forward with your Car Loan Offer!"/>
        <Paragraph size="p0" textAlign="center">
            Your loan contract is being prepared and will be emailed to you shortly!
        </Paragraph>
        <Paragraph size="p0" textAlign="center">
        <strong>Your final step is to:</strong><br />
        open and view your contract &amp;<br />
        electronically sign it
        </Paragraph>
        <Paragraph size="p0" textAlign="center">
        To do this, simply enter the SECURITY CODE we have sent to your mobile number.
        </Paragraph>
        <Paragraph size="p0" textAlign="center">
        Once electronically signed, your loan funds will be transferred to your account!
        </Paragraph>
        <Paragraph size="p0" textAlign="center">
        If you need any assistance, please call us on <a href={`tel:${phone}`}>{phone}</a>.
        <br />
        Go forward with us!
        </Paragraph>
    </AcceptAutoFinanceWrapper>
  );
}
